<template>
    <div class="bcgl">
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">客户类型管理</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>
                                <el-button v-if="isAuth('customertype:add')" type="primary" @click="addOrUpdate()" icon="el-icon-plus" style="display: inline;">添加</el-button>
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :data="customerTypeList" v-loading="loading" style="text-align: center; width: 100%;">
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                    </el-table-column>

                    <el-table-column prop="name" label="类型名称">
                    </el-table-column>
                    <el-table-column  label="备注" show-overflow-tooltip  prop="bz">
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="isAuth('customertype:update')"  @click="addOrUpdate(scope.row.id)">修改</el-button>
                            <el-button type="text" size="mini" v-if="isAuth('customertype:delete')" @click="deleteHandle(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
            <el-dialog title="新增/更新"
                       :visible.sync="addOrUpdateVisible">
                <el-form ref="dataForm" :model="dataForm" label-width="80px">
                    <el-form-item label="类型名称">
                        <el-input v-model="dataForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="dataForm.bz"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交</el-button>
                        <el-button @click="addOrUpdateVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        name: "customer-type",
        data () {
            return {
                currentNo: 1,
                pageSize: 10,
                pageTotal: 0,
                searchForm: {
                    name: ''
                },
                customerTypeList:[],
                addOrUpdateVisible:false,
                dataForm: {
                    id: '',
                    name: '',
                    bz: ''
                },
            }
        },
        created(){

        },
        mounted() {
            this.searchData()
        },
        methods: {
            getParams() {
                this.searchForm.page = this.currentNo
                this.searchForm.pagesize = this.pageSize
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.searchData();
            },
            handleCurrentChange(val) {
                this.currentNo = val;
                this.searchData();
            },
            changeIndex(){
                this.currentNo=1
            },
            searchData(){
                this.getParams()
                this.loading = true;
                this.$request({
                    url: '/bjba/customertype/findPage',
                    method: 'get',
                    params: this.searchForm
                })
                    .then(response => {
                        this.loading = false;
                        console.log(response);
                        let data = response.data;
                        if (data.code == 200) {
                            this.customerTypeList = data.data.content;
                            this.pageTotal = data.data.totalElements
                        } else {
                            this.$message.error(data.message)
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error)
                        this.$message.error(msg)
                    });
            },
            deleteHandle (id) {
                console.log(id)
                this.$confirm(`确定进行[删除]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: `/bjba/customertype/delete`,
                        method: 'post',
                        params: {id:id}
                    }).then(({data}) => {
                        if (data && data.code === 200) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500
                            })
                            this.searchData()
                        } else if(data && data.code ==500) {
                            this.$message({
                                message: data.message,
                                type: 'error',
                                duration: 1500
                            })
                        }
                    })
                }).catch(() => {
                })
            },
            addOrUpdate(val){
                this.addOrUpdateVisible=true;
                this.dataForm={
                    id: '',
                    name: '',
                    bz: ''
                }
                if(val) {
                    this.$http({
                        url: '/bjba/customertype/info/'+val,
                        method: 'get'
                    }).then(({data}) => {
                        this.dataForm.id = data.data.id
                        this.dataForm.name = data.data.name
                        this.dataForm.bz = data.data.bz
                    })
                }
            },
            onSubmit(){
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: `/bjba/customertype/save`,
                            method: 'post',
                            data: this.dataForm
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.addOrUpdateVisible = false
                                this.searchData()
                            } else if(data && data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>